
const EvaluatorsList = () => {
    return (
        <tr className="eval-table-row">
            <td>BCA</td>
            <td>V</td>
            <td>John</td>
            <td>Java</td>
            <td>1</td>
        </tr>

    )
}

export default EvaluatorsList;







